import { memo } from 'react';
import Chip from '../Chip';
import Grid from '../Grid';
import Typography from '../Typography';
import { AY1, S5 } from '../../theme';

export interface IChipsGroupProps {
  dataset: any[];
  getMetadata: (item: any) => { key: string, label: string }
  background?: string;
  typographyColor?: string;
  typographyVariant?: string;
}

const ChipsGroup = (props: IChipsGroupProps) => {
  const {
    dataset = [],
    getMetadata,
    background = AY1,
    typographyColor = S5,
    typographyVariant = 'caption',
  } = props;

  return (
    <Grid container spacing={0.5}>
      {
        dataset.map((data) => {
          const { key, label } = getMetadata(data);
          return (
            <Grid item key={key}>
              <Chip
                size="small"
                typographyVariant="caption"
                background={background}
                label={(
                  <Typography
                    color={typographyColor}
                    variant={typographyVariant}
                  >
                    {label}
                  </Typography>
                )}
              />
            </Grid>
          );
        })
      }
    </Grid>
  );
};

export default memo(ChipsGroup);
